import { AuthDeviceDB } from '@/accessors/indexedDB/authDeviceDB'
import MiiaFwConfig from '@/configs/config'
import { useApiGw } from '@/modules/miiaFw/composables/useApiGw'
import {
  type ResQueryAdminDistricts,
  type ArgQueryAdminDistricts,
  isArgQueryAdminDistricts
} from '@/types/accessor/api/adminDistricts/adminDistricts'

const authDeviceDB = AuthDeviceDB.instance

export const queryAdminDistrictsItem = async (
  arg: ArgQueryAdminDistricts
): Promise<ResQueryAdminDistricts> => {
  const { invokeApiGwFunc } = useApiGw()
  const deviceToken = await authDeviceDB.getDeviceToken()
  return await new Promise((resolve, reject) => {
    if (isArgQueryAdminDistricts(arg)) {
      invokeApiGwFunc(
        // API Gatewayのエンドポイント
        MiiaFwConfig.config.apiGwEndpointCommon,
        // Lambda関数をコールするためのWebAPIのサブディレクトリ
        '/adminDistricts',
        // Lambda関数に渡す引数
        {
          function: 'query',
          // TODO: disaster-commonの設定追加後にsystem: 'disaster-emergency'に変える
          params: { ...arg, system: 'disaster-emergency', deviceToken: deviceToken }
        },
        // Lambda関数実行前の前処理のコールバック
        () => {},
        // 成功時のコールバック
        (data: ResQueryAdminDistricts) => {
          resolve(data)
        },
        // 例外受信時のコールバック(引数: エラーメッセージ)
        err => {
          reject(err)
        },
        // 予期せぬエラー(アクセス回線障害など)発生時のコールバック
        () => {
          reject({ message: 'API実行に失敗しました。(原因: アクセス回線障害など)' })
        },
        // 処理完了後に実行するコールバック
        () => {},
        false,
        true
      )
    } else {
      reject({
        message: {
          code: '210004',
          message: 'リクエスト引数の型が不正です。'
        }
      })
    }
  })
}
